import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NotFoundComponent } from './components/not-found/not-found.component';
import { Checkout2Component } from './components/checkout2/checkout2.component';

import { environment } from './../../../environments/environment';

let routes: Routes = [
  {
    path: 'checkout/404',
    component: NotFoundComponent,
    data: { title: '404' }
  },
  {
    path: 'checkout2',
    component: Checkout2Component,
    data: { title: 'Checkout' }
  },
];

// Does not show in production
if (environment.production) {
  routes = [];
}

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class Checkout2RoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/checkout2/checkout2-routing.module.ts